const LOADING_ACTIONS = {
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER:'HIDE_LOADER',
};
export default LOADING_ACTIONS;
